Profile = require './profile.coffee'

module.exports = class Representative extends Profile
  idAttribute: 'default_profile_id'
